module.exports = __webpack_public_path__ + "img/thumb_03.fddde94d.jpg";